import { useEffect, useState } from "react";
import "./orders.css";
import axios from "axios";

export default function Orders({ branchName }) {
  const [listOfOrders, setListOfOrders] = useState([]);
  useEffect(() => {
    document.querySelector("title").textContent = "MAED | Receipts";
    document.querySelectorAll(".navbar").forEach((nav) => {
      nav.classList.toggle("active", false);
      if (nav.getAttribute("data-id") === "Receipts") {
        nav.classList.toggle("active", true);
      }
    });
    document.getElementById("loading-wrapper").classList.toggle("off", true);
    const data = {
      qr_token: localStorage.getItem("b"),
      tt: localStorage.getItem("tt"),
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}/orders/track`, {
        params: data,
      })
      .then((res) => {
        setListOfOrders(res.data);
      });
  }, []);
  return (
    <main>
      <div className="orders-wrapper">
        <h2>Order History</h2>

        {listOfOrders.map((i) => {
          return <OrderDetailCard order={i} key={i.order_number} />;
        })}
      </div>
    </main>
  );
}

function OrderDetailCard({ order }) {
  const dateStyle = {
    fontStyle: "italic",
    color: "grey",
    display: "block",
    fontSize: "0.7em",
  };
  return (
    <div className="card rounded">
      <div className="card-content">
        <section>
          {order.order_items.map((item, i) => {
            return (
              <p key={i} className="card-title">
                {item.product_name_snapshot} x {item.quantity}
              </p>
            );
          })}
        </section>
      </div>

      <div className="card-price">
        <p>ETB {order.total_price}</p>
      </div>
      <span style={dateStyle}>{order.created_at.split("T")[0]}</span>
      <p className={`status ${order.status}`}>{order.status}</p>
    </div>
  );
}
